"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountForJobView = void 0;
const typeorm_1 = require("typeorm/browser");
const job_1 = require("../job");
const base_account_1 = require("../base-account");
const contact_1 = require("../contact");
class AccountForJobView extends base_account_1.BaseAccount {
}
__decorate([
    (0, typeorm_1.Column)('float8', {
        nullable: true,
        name: 'servicearea__c',
    }),
    __metadata("design:type", Number)
], AccountForJobView.prototype, "serviceArea", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => job_1.Job),
    __metadata("design:type", job_1.Job)
], AccountForJobView.prototype, "job", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => contact_1.Contact, (contact) => contact.account),
    __metadata("design:type", Array)
], AccountForJobView.prototype, "contacts", void 0);
exports.AccountForJobView = AccountForJobView;
//# sourceMappingURL=account-for-job-view.js.map